import { paletteTheme } from "@configs/theme/custom/palette";

export const progressTheme = {
  titleFontSize: 20,
  fontFamily: "RedHatDisplayMedium",
  defaultColor: paletteTheme.colorPrimary,
  remainingColor: paletteTheme.colorBorderSecondary,
};
